/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedFeedsSkeleton.defs'
export { main as default } from './getSuggestedFeedsSkeleton.defs'
